// Disable due to core architecture
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { formatMessage, MainMenuContribution, withModulesManager } from '@openimis/fe-core';
import {
  RIGHT_TASKS_MANAGEMENT_SEARCH_ALL,
  TASKS_MANAGEMENT_MAIN_MENU_CONTRIBUTION_KEY,
} from '../constants';

function TasksMainMenu(props) {
  const { rights } = props;
  const entries = [
    {
      text: formatMessage(props.intl, 'tasksManagement', 'entries.tasksManagementView'),
      icon: <AssignmentIcon />,
      route: '/tasks',
      id: 'task.tasks',
    },
    {
      text: formatMessage(props.intl, 'tasksManagement', 'entries.tasksManagementAllView'),
      icon: <AssignmentIcon />,
      route: '/AllTasks',
      filter: (rights) => rights.includes(RIGHT_TASKS_MANAGEMENT_SEARCH_ALL),
      id: 'task.allTasks',
    },
  ];
  entries.push(
    ...props.modulesManager
      .getContribs(TASKS_MANAGEMENT_MAIN_MENU_CONTRIBUTION_KEY)
      .filter((c) => !c.filter || c.filter(rights)),
  );

  return (
    <MainMenuContribution
      {...props}
      header={formatMessage(props.intl, 'tasksManagement', 'tasksMainMenu')}
      icon={<AssignmentIcon />}
      entries={entries}
      menuId="TasksMainMenu"
    />
  );
}

const mapStateToProps = (state) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
});

export default withModulesManager(injectIntl(connect(mapStateToProps)(TasksMainMenu)));
